<template>
    <div class="fhv-centent"  >
        <h4 class="title-topic">Firewall Setting</h4>
        <el-form
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            v-loading="loading"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable Firewall:" >
                <el-switch v-model="firewallEnable" @change="setData('firewall')"></el-switch>
            </el-form-item>
            <el-form-item label="Enable SPI:" >
                <el-switch v-model="SPIEnable" @change="setData('SPI')"></el-switch>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            firewallEnable: false,
            SPIEnable:false
        }
    },
    created(){
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"GET_WEB_FIREWALL"
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.firewallEnable = response.data.firewallEnable
                    this.SPIEnable = response.data.SPIEnable
                }
                else
                    this.$message.error(`GET data failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('GET data failed! Network connection error!')
            })
        },
        setData(type) {
            let postData = {
                cmdType:"SET_WEB_FIREWALL"
            }

            if(type === 'firewall')
                postData.firewallEnable = this.firewallEnable
            else if(type === 'SPI')
                postData.SPIEnable = this.SPIEnable
            else
            {
                this.$message.error("setData type error!")
                return
            }
                

            this.loading = true
            axios
            .post("/JSONAPI",postData)
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('Configuration is success!')
                }
                else
                    this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Configuration failed! Network connection error!')
            })
        }
    },
}
</script>

<style lang="scss" scoped>

</style>